import { useMutation } from "@tanstack/react-query";
import { QUERY_KEYS } from "../../../constants/queryKeys";
import { MultipartUploadParams } from "../../../store/actions/fileVersions";
import {
  assertEngineEarsErrorType,
  displayEngineEarsError,
} from "../../helpers";
import {
  MarkArchived,
  markReleaseTrackFileAsUploadedAPI,
} from "../releaseTrackFileVersionAPI";

export interface MarkReleaseTrackFileParams {
  fileVersionId: number;
  args?: MultipartUploadParams | MarkArchived;
}

export const useMarkReleaseTrackFileAsUploaded = () => {
  return useMutation({
    mutationKey: [QUERY_KEYS.MARK_RELEASE_TRACK_FILE_AS_UPLOADED],
    mutationFn: async (params: MarkReleaseTrackFileParams) => {
      return markReleaseTrackFileAsUploadedAPI(
        params.fileVersionId,
        params.args,
      );
    },
    onError: (error) => {
      if (assertEngineEarsErrorType(error)) {
        displayEngineEarsError(error);
      }
    },
  });
};
